module.exports = __webpack_public_path__ + "static/media/down.abb86c51.svg";